"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * New Api\'s for all previews
 * These are the new endpoints for preview panes.
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: ggrigorian@tivo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenType = void 0;
/**
 * ScreenType.
 * @export
 * @enum {string}
 */
exports.ScreenType = {
    ActionScreen: 'actionScreen',
    ActionScreenEpisodeItem: 'actionScreenEpisodeItem',
    ActionScreenMayAlsoLikeList: 'actionScreenMayAlsoLikeList',
    ActionScreenMayAlsoLikeStrip: 'actionScreenMayAlsoLikeStrip',
    ActionScreenUpcomingList: 'actionScreenUpcomingList',
    ActionScreenUpcomingStrip: 'actionScreenUpcomingStrip',
    AlreadyRecordingOverlay: 'alreadyRecordingOverlay',
    FullBanner: 'fullBanner',
    GuideHeader: 'guideHeader',
    GuideRecordOverlay: 'guideRecordOverlay',
    InfoCard: 'infoCard',
    LiveTvBanner: 'liveTvBanner',
    OneLineGuide: 'oneLineGuide',
    PersonScreenGallery: 'personScreenGallery',
    PersonScreenStrip: 'personScreenStrip',
    PredictionStrip: 'predictionStrip',
    SearchScreen: 'searchScreen',
    SeriesScreen: 'seriesScreen',
    SeriesScreenItem: 'seriesScreenItem',
    SeriesScreenMayAlsoLikeList: 'seriesScreenMayAlsoLikeList',
    SeriesScreenUpcoming: 'seriesScreenUpcoming',
    StandardBanner: 'standardBanner',
    ToDoList: 'toDoList',
    WtwnScreen: 'wtwnScreen',
    All: 'all'
};
